module.exports = __webpack_public_path__ + "img/seal_warrior.03297174.svg";